export function resolvedJsonDataURL({ sport, origin, path }) {
  const hostname = (() => {
    try { return new URL(origin).hostname; } catch { return ""; }
  })();
  const isProductionHost = /(?:\.netlify\.app|playswithguru\.com)$/i.test(hostname);
  if (isProductionHost) throw new Error(`Same-origin production JSON is disabled for ${String(sport || "UNKNOWN").toUpperCase()}.`);
  return `${origin}${path}`;
}

export function resolvedApiDataURL({ sport, dataBase, path }) {
  throw new Error(`Sports API fallback is disabled for ${String(sport || "UNKNOWN").toUpperCase()}.`);
}
